import type { CarrierDto } from "@babackapp/private-api-client/types";

type CarrierPrefs = CarrierDto["preferences"];

// Only carriers whose tracking gateway calls getCredentials(shopId) — i.e. per-shop
// credentials fetched from ShopTrackingCarrier or legacy carrier.preferences.
//
// Excluded (no per-shop tracking credentials needed):
//   colissimo, chrono-shop2shop → LaposteCompositeGateway (web scraping / global OKapi key)
//   chronopost, chronopost-18, chrono-relais → public Chronopost SOAP API (no auth)
//   dhl + variants → DhlScraperConfigService (global scraper config)
//   tnt → TrackingMoreGateway (global API key)
//   malca → no tracking gateway implementation
const REQUIRED_FIELDS: Partial<Record<string, (keyof CarrierPrefs)[]>> = {
  // SOAP V1: brand + securityKey; V2 falls back to shared web scraper (no per-shop creds)
  "mondial-relay": ["securityKey", "brand"],
  // DpdCompositeGateway → DpdGateway → DpdCredentialStrategy
  dpd: [
    "userid",
    "password",
    "customerCountryCode",
    "customerCenterNumber",
    "customerNumber",
  ],
  // SeurGateway → SeurCredentialStrategy (businessUnit + idNumber stored in DB but absent from DTO)
  seur: ["clientId", "clientSecret", "username", "password", "accountNumber"],
};

export function isMissingTrackingCredentials(carrier: CarrierDto): boolean {
  const required = REQUIRED_FIELDS[carrier.code.toLowerCase()];
  if (!required) return false;
  return required.some((field) => !carrier.preferences[field]);
}
